export default __webpack_public_path__ + "assets/color.3487210c.svg";